import styled from "styled-components";

export const AuthenticateModalTitle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  color: #e0edef;
  font-size: 18px;
  font-weight: 600;
  background: #18191b;
  height: 80px;
  padding: 15px 24px;
  p {
    margin: 0;
  }
`;
export const AuthenticateModalTip = styled.div`
  color: #e0edef;
  font-size: 14px;
  font-weight: 400;
  margin-top: 6px;
`;
export const CoupnTip = styled.div`
  background: linear-gradient(
    90deg,
    rgba(217, 217, 217, 0) 0.08%,
    rgba(139, 194, 201, 0.12) 35.19%,
    rgba(101, 182, 193, 0.28) 52.68%,
    rgba(148, 196, 203, 0.14) 71.2%,
    rgba(217, 217, 217, 0) 97.83%
  );
  height: 32px;
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    background: linear-gradient(
      97.74deg,
      #1bf2ff -2.06%,
      #43ffd2 35.12%,
      #6cf5a3 67.15%,
      #fff587 89.79%
    );
    -webkit-background-clip: text;
    color: transparent;
    font-size: 14px;
    font-weight: 600;
    span {
      font-size: 20px;
    }
  }

  .icon {
    width: 30px;
    height: 30px;
  }
  .text {
    width: 278px;
    height: 28px;
  }
`;

export const AuthenticateModalWrapper = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  .more-text {
    color: #13cb75;
    margin-bottom: 12px;
    cursor: pointer;
  }
`;

export const AuthenticateContent = styled.div`
  display: flex;
  align-items: center;
  color: #e0edef;
`;

export const AuthenticateItem = styled.div`
  margin: 20px 50px 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    margin-bottom: 7px;
  }
  div {
    width: 168px;
    height: 168px;
    background: #202225;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      margin-bottom: 12px;
    }
    span {
      color: #687778;
      line-height: 17px;
    }
  }
  .tips {
    margin-top: 6px;
    display: flex;
    gap: 4px;
  }
  &.enterprise {
    cursor: pointer;
  }
`;
export const Line = styled.div`
  width: 1px;
  height: 220px;
  background-color: #343538;
`;

export const ModalWrapper = styled.div``;

export const AuthStatusWrapper = styled.div`
  width: 600px;
  height: 400px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #e0edef;
  svg {
    width: 120px;
    height: 120px;
  }
  .title {
    font-size: 20px;
    font-weight: 600;
    margin: 10px 0 8px;
  }
  .message {
    font-size: 16px;
    margin: 0;
  }
  button {
    margin: 98px 0 16px;
    width: 86px;
  }
`;
